/**
 * Get KANDY User Access Token(UAT) from the locally stored token
 */
let lu = [];

let getUserAccessToken = () => {
    return window.accessToken
};
let setUserAccessToken = (userAccessToken) => {
    window.accessToken = userAccessToken
};
let removeUserAccessToken = () => {
    window.accessToken = null
};

let setKandyUAT = (token) => {
	localStorage.setItem('token', token)
};
let setKandyUserName = (username) => {
	localStorage.setItem('username', username)
};
let setKandyPassword = (password) => {
	localStorage.setItem('password', password)
};
let removeKandyUAT = () => {
	localStorage.removeItem('token')
};
let removeKandyUserName = () => {
	localStorage.removeItem('username')
};
let removeKandyPassword = () => {
	localStorage.removeItem("password")
};
let getRememberMe = () => {
	return localStorage.rbm
};
let setRememberMe = () => {
	localStorage.setItem('rbm', true);
};
let removeRememberMe = () => {

	localStorage.removeItem('rbm');
};

let getLocalUser = () => {
	return JSON.parse(localStorage['localUser'])
};

let setLocalUser = (name, password) => {

	let user = {};
	user[name] = password;
	lu.push(user);
	localStorage['localUser'] = JSON.stringify(lu);

};

let removeLocalUser = () => {
	localStorage['localUser'] = undefined;
};

/**
 * Returns the Logged in state as either True or False
 */
let loggedIn = () => {
	return !!getUserAccessToken() // Converts Object into Boolean
};
/**
 * html5内存记录agent中userType值
 * @param userType
 */
let setAgentUserType = (userType) =>{
    localStorage.setItem('userType', userType)
}
let getAgentUserType = () =>{
    return localStorage.userType
}
let removeAgentUserType = () =>{
    localStorage.removeItem('userType')
}
export {
    getUserAccessToken,
    setUserAccessToken,
    removeUserAccessToken,
	setKandyUAT,
	removeKandyUAT,
	loggedIn,
	setKandyUserName,
	setKandyPassword,
	removeKandyUserName,
	removeKandyPassword,
	setRememberMe,
	getRememberMe,
	removeRememberMe,
	setLocalUser,
	getLocalUser,
	removeLocalUser,
    setAgentUserType,
    getAgentUserType,
    removeAgentUserType
}
